import { render } from "./ReviewPage.vue?vue&type=template&id=6ac4558e"
import script from "./ReviewPage.vue?vue&type=script&lang=js"
export * from "./ReviewPage.vue?vue&type=script&lang=js"

import "./ReviewPage.vue?vue&type=style&index=0&id=6ac4558e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__